import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { apiService } from '../../services';
import { errorToMessage, fixID } from '../../helpers';
import BaseSmsOpt from './BaseSmsOpt';
import { withTranslation } from 'react-i18next';


const PAGE_PREFIX = 'sms_opt';
class SmsOptOut extends React.Component {
  constructor(props) {
    super(props);

    const { match: { params: { parcelID, type: communicationType } } } = props;

    const fixedParcelID = fixID(parcelID);
    this.params = { 
      id: fixedParcelID ,
      type: 'pid',
      communicationType: communicationType || 'sms'
    }

    this.state = {parcel:null, error:null, commData:null, status:null, showBtn:true};
  }

  getText(type){
    const { t } = this.props;
    const { commData, status } = this.state;
    if (status === 'blocked') {
      return t(`messageOptOut_${type}`, {commData});
    }
    return '';
  }

  unsubscribeText(type){
    const { commData } = this.state;
    const { t } = this.props;
    return t(`stopMsg_${type}`, {commData});
  }

  subscribeText(type){
    const { commData } = this.state;
    const { t } = this.props;
    return t(`continueMsg_${type}`, {commData});
  }

  componentDidMount() {
    this.getParcelBySMS();
    this.getCommunicationData();
  }

  getParcelBySMS() {
    const { getParcelBySMSAPI }= this.props;

    const { id } = this.params;
    if (!id) {
      this.setState({error: 'תקלה בקבלת פרטי החבילה. אנא ודאו שכתובת הדף הוכנסה במלואה.'});
      return;
    }

    apiService
      .callServer(
        getParcelBySMSAPI, { ':id:': id }, null, null, null, true
      )
      .then(
        _ => {
          this.setState({parcel: _});
        },
        error => {
          this.setState({error: errorToMessage(error)});
        }
      );
  }


  getCommunicationData() {
    const {
      getCommunicationDataAPI, match: { params: { parcelID } }
    } = this.props;

    const { id, type, communicationType } = this.params;
    if (!id) {
      this.setState({error: 'תקלה בקבלת פרטי החבילה. אנא ודאו שכתובת הדף הוכנסה במלואה.'});
      return;
    }

    const query = `communicationType=${communicationType}`;
    apiService
      .callServer(
        getCommunicationDataAPI, { ':id:': id, ':type:': type}, query, null, null, true
      )
      .then(
        _ => {
          this.setState({commData: _.data});
          this.setState({status: _.status});
          if( _.status === 'blocked') {
            this.setState({showBtn: false});
          }
        },
        error => {
          this.setState({error: errorToMessage(error)});
        }
      );
  }

  render() {
    const { parcel, commData, error, showBtn } = this.state;
    const type = this.params.communicationType;
    return (
      <BaseSmsOpt parcel={parcel} error={error} {...this.params} message={this.getText(type)}
        opt1={this.unsubscribeText(type)}
        opt2={this.subscribeText(type)}
        communicationData={commData}
        showBtn={showBtn}
        communicationType={type}
        btnIgnoreClass='left'>
      </BaseSmsOpt>
    );
  }

}

function mapStateToProps(state) {
  const { getParcelBySMS, updateSmsServicesOpt, getCommunicationData } = state.api;
  return {
    getParcelBySMSAPI: getParcelBySMS,
    updateSmsServicesOptAPI: updateSmsServicesOpt,
    getCommunicationDataAPI: getCommunicationData
  };
}

// withRouter will set the location as this.props.location
export default  withTranslation(PAGE_PREFIX)(withRouter(connect(mapStateToProps)(SmsOptOut)));

